export default __webpack_public_path__ + "static/Average May temp 2000-15dc60e3833aa3d262ed05c50c76f7a8.png";